import { render, staticRenderFns } from "./NewMenuManagementV2.vue?vue&type=template&id=f31d9d1c&scoped=true"
import script from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
export * from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
import style0 from "./NewMenuManagementV2.vue?vue&type=style&index=0&id=f31d9d1c&prod&lang=scss&scoped=true"
import style1 from "./NewMenuManagementV2.vue?vue&type=style&index=1&id=f31d9d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31d9d1c",
  null
  
)

export default component.exports